import {
  SET_FORECAST_DEPRECIATION_DATA,
  SET_FORECAST_DEPRECIATION,
} from "./mutations";
import forecastDepreciationData from "./test_forcasted_depreciation.json";

const initialState = {
  data: forecastDepreciationData,
  forecastedDepreciation: null
};

const forecastDepreciationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_DEPRECIATION_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          forecastedDepreciation: {
            ...payload.forecastedDepreciation,
          },
        },
      };
    }

    case SET_FORECAST_DEPRECIATION:
      return { ...state, forecastedDepreciation: payload }

    default:
      return state;
  }
};

export default forecastDepreciationReducer;
